module.exports = __webpack_public_path__ + "static/media/client-14.48978e39.jpg";